module.exports = __webpack_public_path__ + "static/media/Munir Uddin Mahbub.cb21c6d7.png";